exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".g7E-u_vp-4q4s1hA0NXBR{width:34px!important}html[dir] .g7E-u_vp-4q4s1hA0NXBR{margin-top:8px}html[dir=ltr] .g7E-u_vp-4q4s1hA0NXBR{margin-right:7px}html[dir=rtl] .g7E-u_vp-4q4s1hA0NXBR{margin-left:7px}html[dir] ._2Vmg5FNbfJm9MG6qrM3ODx{margin-bottom:17px;margin-top:9px}", ""]);
// Exports
exports.locals = {
	"quickComposeIcon": "g7E-u_vp-4q4s1hA0NXBR",
	"composeAttendeeRow": "_2Vmg5FNbfJm9MG6qrM3ODx"
};